import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
export default SyntaxHighlighter;
